/**
 * Holiday Plugin - Automatically enables holiday CSS during Christmas and New Year period
 * Active Period: December 15 - January 5 (EVERY YEAR)
 *
 * This will automatically activate every year without code changes!
 *
 * To manually disable:
 * 1. Delete this file (plugins/holiday.client.ts)
 * 2. Delete assets/css/holiday.css
 * 3. Restart the dev server or rebuild
 */

export default defineNuxtPlugin(() => {
  const now = new Date();
  const month = now.getMonth() + 1; // 1-12
  const day = now.getDate();

  // Check if we're in the holiday period (Dec 15 - Jan 5)
  // December 15-31 OR January 1-5
  const isHolidayPeriod = (month === 12 && day >= 15) || (month === 1 && day <= 5);

  if (!isHolidayPeriod) {
    console.log('Holiday CSS disabled - outside holiday period (Dec 15 - Jan 5)');
    return;
  }

  console.log('Holiday CSS enabled - Happy Holidays! 🎄🎉');

  // Import the holiday CSS
  if (process.client) {
    import('~/assets/css/holiday.css');

    // Wait for DOM to be ready
    window.addEventListener('DOMContentLoaded', () => {
      addHolidayEffects();
    });

    // Fallback if DOMContentLoaded already fired
    if (document.readyState === 'loading') {
      // DOM is still loading
    } else {
      // DOM is already loaded
      addHolidayEffects();
    }
  }
});

function addHolidayEffects() {
  // Add holiday theme class to body
  document.body.classList.add('holiday-theme');

  // Create snowflakes container
  const snowflakesContainer = document.createElement('div');
  snowflakesContainer.className = 'holiday-snowflakes';

  // Create 12 snowflakes with random starting positions
  for (let i = 0; i < 12; i++) {
    const snowflake = document.createElement('div');
    snowflake.className = 'snowflake';
    snowflake.textContent = '❄';

    // Randomize initial vertical position so they don't all start at top
    const randomTop = Math.random() * 100; // 0-100vh
    snowflake.style.top = `${randomTop}vh`;

    snowflakesContainer.appendChild(snowflake);
  }

  document.body.appendChild(snowflakesContainer);

  // Add floating ornaments (reduced to 2)
  const ornaments = ['🎁', '⛄'];
  ornaments.forEach((ornament, index) => {
    const ornamentEl = document.createElement('div');
    ornamentEl.className = 'holiday-ornament';
    ornamentEl.textContent = ornament;
    document.body.appendChild(ornamentEl);
  });

  // Add festive background overlay
  const bgOverlay = document.createElement('div');
  bgOverlay.className = 'holiday-bg-overlay';
  document.body.insertBefore(bgOverlay, document.body.firstChild);

  // Add twinkling stars (reduced to 4)
  const starPositions = [
    { top: '15%', left: '8%' },
    { top: '25%', right: '10%' },
    { top: '70%', left: '12%' },
    { top: '75%', right: '15%' }
  ];

  starPositions.forEach((position) => {
    const star = document.createElement('div');
    star.className = 'holiday-star';
    star.textContent = '✨';
    Object.assign(star.style, position);
    document.body.appendChild(star);
  });

  // Optionally add festive decorations to the main header/logo
  // This is commented out by default - uncomment if you want header decorations
  /*
  const mainHeader = document.querySelector('h1, .logo, header h1');
  if (mainHeader) {
    mainHeader.classList.add('holiday-decoration');
  }
  */

  // Add festive border to main content
  const mainContent = document.querySelector('main, .main-content, #app > div');
  if (mainContent) {
    mainContent.classList.add('holiday-border');
  }
}
